import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ExportExcelDevice extends Component {

    render() {
    const { dataExcel } = this.props;
    return (
        <div>
        {dataExcel.length > 0 &&
            <ExcelFile>
                <ExcelSheet border={1} data={dataExcel} name={'data'}>
                    <ExcelColumn label={'device_id'}  value={'device_id'}/>
                    <ExcelColumn label={'device_no'}  value={'device_no'}/>
                    <ExcelColumn label={'imei'}  value={'imei'}/>
                    <ExcelColumn label={'model'}  value={'model'}/>
                    <ExcelColumn label={'sim_no'}  value={'sim_no'}/>
                    <ExcelColumn label={'network_operator'}  value={'network_operator'}/>
                    <ExcelColumn label={'create_user'}  value={'create_user'}/>
                    <ExcelColumn label={'tracking_dtm'}  value={'tracking_dtm'}/>
                </ExcelSheet>
            </ExcelFile>
        }
        </div>
        );
    }
}

ExportExcelDevice.propTypes = {
    dataExcel: PropTypes.array.isRequired
}

export default ExportExcelDevice;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/ExportExcel/ExportExcelDevice.js